import {
  BufferGeometry,
  Float32BufferAttribute,
  Line,
  MathUtils
} from 'three';
import { sceneManager} from '../script';

import { createLineShaderMaterial } from './magneticPoloidal';

export function createConcentricMagneticLines(count = 60, points = 20, minR = 2, maxR = 12, mesh) {
  const lines = [];
  const material = createLineShaderMaterial();

  material.uniforms.fadeSet = { value: true };
  material.transparent = true;
  material.uniforms.fadeStart = { value: 0.75 };
  for (let i = 0; i < count; i++) {
    const geom = new BufferGeometry();
    const pos = new Float32Array(points * 3);
    const uv = new Float32Array(points * 2);
    const baseAngles = new Float32Array(points);
    const baseRadii = new Float32Array(points);
    const arcLen = MathUtils.randFloat(Math.PI * 0.5, Math.PI * 2);
    const startAng = MathUtils.randFloat(0, Math.PI * 2);
    const spinSpeed = MathUtils.randFloat(0.1, 0.4);
    const twistAmp = MathUtils.randFloat(0.5, 2);
    const radius = MathUtils.randFloat(minR, maxR);
    for (let j = 0; j < points; j++) {
      const t = j / (points - 1);
      const twist = Math.sin(t * Math.PI * twistAmp) * (1 - t) * 0.6;
      const ang = startAng + t * arcLen + twist;
      baseAngles[j] = ang;
      const r = radius * (1 + Math.sin(t * Math.PI * 2 * twistAmp) * 0.06);
      baseRadii[j] = r;
      pos[3*j]   = Math.cos(ang) * r;
      pos[3*j+1] = 0;
      pos[3*j+2] = Math.sin(ang) * r;
      uv[2*j]   = t;
      uv[2*j+1] = 0;
    }
    geom.setAttribute('position', new Float32BufferAttribute(pos, 3));
    geom.setAttribute('uv', new Float32BufferAttribute(uv, 2));
    geom.userData = { baseAngles, baseRadii, spinSpeed };
    const line = new Line(geom, material)
    lines.push(line);
    sceneManager.scene.add(line)
    mesh.add(line)
    
  }
  return lines;
}

export function createWavyColumnLines(count = 30, points = 120, height = 8, maxR = 1, taper = 0.5, twist = 3, up = true, mesh) {
  const lines = [];
  const material = createLineShaderMaterial();
  for (let i = 0; i < count; i++) {
    const geom = new BufferGeometry();
    const pos = new Float32Array(points * 3);
    const uv = new Float32Array(points * 2);
    const baseRadius = MathUtils.randFloat(maxR * 0.5, maxR);
    const speed = MathUtils.randFloat(0.2, 0.8);
    const phase = MathUtils.randFloat(0, Math.PI * 2);
    const chaosAmp = MathUtils.randFloat(0.2, 0.6);
    const chaosFreq = MathUtils.randFloat(1.5, 3);
    for (let j = 0; j < points; j++) {
      const t = j / (points - 1);
      const y = (up ? 1 : -1) * height * t;
      const angle = phase + t * twist * Math.PI * 2;
      const rBase = baseRadius * Math.pow(taper, t);
      const wave = Math.sin(angle * chaosFreq + phase + i) * chaosAmp * (1 - t);
      const r = rBase + wave;
      pos[3*j]   = Math.cos(angle) * r;
      pos[3*j+1] = y;
      pos[3*j+2] = Math.sin(angle) * r;

      uv[2*j]   = t;
      uv[2*j+1] = t;
    }
    geom.setAttribute('position', new Float32BufferAttribute(pos, 3));
    geom.setAttribute('uv', new Float32BufferAttribute(uv, 2));
    geom.userData = { speed, phase, twist, taper, baseRadius, chaosAmp, chaosFreq };

    const line = new Line(geom, material)
    lines.push(line);
    sceneManager.scene.add(line)
    mesh.add(line)
  }
  return lines;
}

export function updateMagneticLines(lines, elapsed) {
  lines.forEach((line, idx) => {
    const pos = line.geometry.getAttribute('position');
    const { baseAngles, baseRadii, spinSpeed } = line.geometry.userData;
    for (let i = 0; i < pos.count; i++) {
      const t = i / (pos.count - 1);
      const ang = baseAngles[i] + spinSpeed * elapsed;
      const r = baseRadii[i] + Math.sin(elapsed * 3 + idx + i) * 0.1;
      pos.array[3*i]   = Math.cos(ang) * r;
      pos.array[3*i+1] = Math.sin(elapsed * 5 + idx + i) * 0.1;;
      pos.array[3*i+2] = Math.sin(ang) * r;
    }
    pos.needsUpdate = true;
    line.visible = sceneManager.commands.controls.magnetosphere
    line.rotateY(-3e-3)
  });
}
export function updateColumnLines(lines, elapsed) {
  lines.forEach((line, idx) => {
    const pos = line.geometry.getAttribute('position');
    const { speed, phase, twist, taper, baseRadius, chaosAmp, chaosFreq } = line.geometry.userData;
    for (let i = 0; i < pos.count; i++) {
      const t = i / (pos.count - 1);
      const angle = phase - t * twist * Math.PI * 2 + elapsed * speed;
      const rBase = baseRadius * Math.pow(taper, t);
      const wave = Math.sin(angle * chaosFreq + elapsed * speed + idx) * chaosAmp * (1 - t);
      const r = rBase + wave;
      pos.array[3*i]   = Math.cos(angle) * r;
      pos.array[3*i+2] = Math.sin(angle) * r;
    }
    pos.needsUpdate = true;
    line.visible = sceneManager.commands.controls.magnetosphere
    line.rotateY(-1.2e-1)
  });
}



